import { render, staticRenderFns } from "./NotificationChangeStatusDoc.vue?vue&type=template&id=71aa8d32"
import script from "./NotificationChangeStatusDoc.vue?vue&type=script&lang=js"
export * from "./NotificationChangeStatusDoc.vue?vue&type=script&lang=js"
import style0 from "./NotificationChangeStatusDoc.vue?vue&type=style&index=0&id=71aa8d32&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports